/**
 * Header Component
 * Navigation bar with responsive mobile hamburger menu
 */

import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import Button from '../common/Button';
import './Header.css';

// Navigation links configuration
const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/what-is-taas', label: 'What is TaaS' },
    { path: '/how-it-works', label: 'How It Works' },
    { path: '/why-taas', label: 'Why TaaS' },
    { path: '/pricing', label: 'Pricing' },
    { path: '/about', label: 'About' },
    { path: '/contact', label: 'Contact' },
];

function Header() {
    // State for mobile menu toggle
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    // State for scroll detection (adds shadow on scroll)
    const [isScrolled, setIsScrolled] = useState(false);

    // Handle scroll effect for header shadow
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 10);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Close mobile menu when clicking a link
    const handleLinkClick = () => {
        setIsMobileMenuOpen(false);
    };

    // Toggle mobile menu
    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    return (
        <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
            <div className="header__container">
                {/* Logo */}
                <Link to="/" className="header__logo" aria-label="CODEMAKER Technology Home">
                    <img
                        src={require('../../assets/images/codemaker-logo-full.png')}
                        alt="CODEMAKER Technology Logo"
                        className="header__logo-image"
                        style={{ height: '40px', width: 'auto' }}
                    />
                </Link>

                {/* Desktop Navigation */}
                <nav className="header__nav" aria-label="Main navigation">
                    {navLinks.map(({ path, label }) => (
                        <NavLink
                            key={path}
                            to={path}
                            className={({ isActive }) =>
                                `header__nav-link ${isActive ? 'active' : ''}`
                            }
                        >
                            {label}
                        </NavLink>
                    ))}
                </nav>

                {/* Desktop CTA Button */}
                <div className="header__cta">
                    <Button as={Link} to="/contact" variant="primary" size="small">
                        Book a Consultation
                    </Button>
                </div>

                {/* Mobile Menu Toggle Button */}
                <button
                    className={`header__menu-toggle ${isMobileMenuOpen ? 'open' : ''}`}
                    onClick={toggleMobileMenu}
                    aria-expanded={isMobileMenuOpen}
                    aria-controls="mobile-nav"
                    aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'}
                >
                    <span className="header__menu-icon" aria-hidden="true"></span>
                </button>
            </div>

            {/* Mobile Navigation Menu */}
            <nav
                id="mobile-nav"
                className={`header__mobile-nav ${isMobileMenuOpen ? 'open' : ''}`}
                aria-label="Mobile navigation"
            >
                {navLinks.map(({ path, label }) => (
                    <NavLink
                        key={path}
                        to={path}
                        className={({ isActive }) =>
                            `header__mobile-nav-link ${isActive ? 'active' : ''}`
                        }
                        onClick={handleLinkClick}
                    >
                        {label}
                    </NavLink>
                ))}
                <div className="header__mobile-cta">
                    <Button
                        as={Link}
                        to="/contact"
                        variant="primary"
                        fullWidth
                        onClick={handleLinkClick}
                    >
                        Book a Consultation
                    </Button>
                </div>
            </nav>
        </header>
    );
}

export default Header;
